import StudentIntakeResults from "@/pages/cursisten/$studentId/intake"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute("/beheer/cursisten/$studentId/intake/")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "students"),
})

function RouteComponent() {
  const { studentId } = useParams({ from: "/beheer/cursisten/$studentId" })

  return <StudentIntakeResults studentId={Number(studentId)} />
}
